import {
  RetailStatusResponseInterface,
  RetailStatusResponseVerificationErrorInterface,
  RetailStatusResponseVerificationRequirementsInterface,
} from '@vendasta/billing';

export enum PaymentFacilitatorError {
  GENERIC_ERROR = 'PAYMENT_PROCESSOR_GENERIC_ERROR',
  PERMISSION_DENIED = 'PAYMENT_PROCESSOR_PERMISSION_DENIED',
}

export interface RetailStatus {
  supportedRegion: boolean;
  canAcceptPayment: boolean;
  disabledReason?: string;
  requirements: Requirements;
  futureRequirements: Requirements;
}

export type RetailStatusInterface = RetailStatus;

export interface Requirements {
  due: string[];
  errors: VerificationError[];
  // related to future requirements
  eventuallyDue: string[];
  // related to future requirements
  currentDeadline?: Date;
}

export interface VerificationError {
  requirement: string;
  code: string;
  reason: string;
}

export function isRejectedDisabledReason(disabledReason: string): boolean {
  return ['rejected.fraud', 'rejected.listed', 'rejected.other', 'rejected.terms_of_service'].includes(disabledReason);
}

function verificationErrorFromAPI(e: RetailStatusResponseVerificationErrorInterface): VerificationError {
  return {
    requirement: e.requirement || '',
    code: e.code || '',
    reason: e.reason || '',
  };
}

function requirementsFromAPI(
  requirements: RetailStatusResponseVerificationRequirementsInterface | undefined,
): Requirements {
  if (!requirements) {
    return { due: [], errors: [], eventuallyDue: [] };
  }
  return {
    due: requirements.due || [],
    errors: (requirements.error || []).map((e) => verificationErrorFromAPI(e)),
    eventuallyDue: requirements.eventuallyDue || [],
    currentDeadline: new Date(requirements.currentDeadline || 0),
  };
}

export function retailResponseFromAPI(proto: RetailStatusResponseInterface): RetailStatus {
  return {
    supportedRegion: proto.supportedRegion || false,
    canAcceptPayment: proto.canAcceptPayment || false,
    disabledReason: proto.disabledReason,
    requirements: requirementsFromAPI(proto.requirements),
    futureRequirements: requirementsFromAPI(proto.futureRequirements),
  };
}
